import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Network } from '@capacitor/network';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private networkStatus = new BehaviorSubject<boolean>(true); // default: connected

  constructor() {
    this.initializeNetworkEvents();
  }

  private async initializeNetworkEvents() {
    const status = await Network.getStatus();
    this.networkStatus.next(status.connected);

    Network.addListener('networkStatusChange', (status) => {
      console.log('Network status changed', status);
      this.networkStatus.next(status.connected);
    });
  }

  getNetworkStatus() {
    return this.networkStatus.asObservable();
  }
}
